import request from '@/utils/request'

/**
 * 获取未读消息
 */
export const unreadNotice = () => request.get('/api/console/notice/count')
